import type { Poll } from './poll'
import type { PollChoice as AwardNominee } from './pollChoice'

enum AwardVoteStatus {
  ACTIVE = 0,
  COUNTING = 1,
  FINAL = 2,
}

interface Award {
  active: 0 | 1
  id: number
  poll_count: number
  name: string
  slug: string
  description: string
  seo_description: string
  seo_title: string
  created_at: string
  vote_status: AwardVoteStatus
}

type AwardNomination = Pick<
  Poll,
  | 'id'
  | 'name'
  | 'active'
  | 'vote_status'
  | 'start_vote_time'
  | 'finish_vote_time'
>

export { AwardVoteStatus }

export type { Award, AwardNomination, AwardNominee }
